<template>
  <div class="notification-tabs">
    <!-- Tab bar -->
    <div class="notification-tabs__header">
      <Tab
        class="notification-tabs__tab-group"
        type="underline"
        :modelValue="activeTab"
        :tabs="tabConfig"
        @change="switchTab"
      >
        <template #icon-0="{ selected }">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M2.25 15C1.625 15 1.09375 14.7812 0.65625 14.3437C0.21875 13.9062 0 13.375 0 12.75C0 12.2625 0.140625 11.825 0.421875 11.4375C0.703125 11.05 1.0625 10.7812 1.5 10.6312V9C1.5 8.375 1.71875 7.84375 2.15625 7.40625C2.59375 6.96875 3.125 6.75 3.75 6.75H6.75V4.36875C6.3125 4.21875 5.95312 3.95 5.67187 3.5625C5.39062 3.175 5.25 2.7375 5.25 2.25C5.25 1.625 5.46875 1.09375 5.90625 0.65625C6.34375 0.21875 6.875 0 7.5 0C8.125 0 8.65625 0.21875 9.09375 0.65625C9.53125 1.09375 9.75 1.625 9.75 2.25C9.75 2.7375 9.60937 3.175 9.32812 3.5625C9.04687 3.95 8.6875 4.21875 8.25 4.36875V6.75H11.25C11.875 6.75 12.4062 6.96875 12.8437 7.40625C13.2812 7.84375 13.5 8.375 13.5 9V10.6312C13.9375 10.7812 14.2969 11.05 14.5781 11.4375C14.8594 11.825 15 12.2625 15 12.75C15 13.375 14.7812 13.9062 14.3437 14.3437C13.9062 14.7812 13.375 15 12.75 15C12.125 15 11.5937 14.7812 11.1562 14.3437C10.7187 13.9062 10.5 13.375 10.5 12.75C10.5 12.2625 10.6406 11.825 10.9219 11.4375C11.2031 11.05 11.5625 10.7812 12 10.6312V9C12 8.7875 11.9281 8.60938 11.7844 8.46562C11.6406 8.32187 11.4625 8.25 11.25 8.25H8.25V10.6312C8.6875 10.7812 9.04687 11.05 9.32812 11.4375C9.60937 11.825 9.75 12.2625 9.75 12.75C9.75 13.375 9.53125 13.9062 9.09375 14.3437C8.65625 14.7812 8.125 15 7.5 15C6.875 15 6.34375 14.7812 5.90625 14.3437C5.46875 13.9062 5.25 13.375 5.25 12.75C5.25 12.2625 5.39062 11.825 5.67187 11.4375C5.95312 11.05 6.3125 10.7812 6.75 10.6312V8.25H3.75C3.5375 8.25 3.35937 8.32187 3.21562 8.46562C3.07187 8.60938 3 8.7875 3 9V10.6312C3.4375 10.7812 3.79687 11.05 4.07812 11.4375C4.35937 11.825 4.5 12.2625 4.5 12.75C4.5 13.375 4.28125 13.9062 3.84375 14.3437C3.40625 14.7812 2.875 15 2.25 15ZM2.25 13.5C2.4625 13.5 2.64062 13.4281 2.78437 13.2844C2.92812 13.1406 3 12.9625 3 12.75C3 12.5375 2.92812 12.3594 2.78437 12.2156C2.64062 12.0719 2.4625 12 2.25 12C2.0375 12 1.85938 12.0719 1.71562 12.2156C1.57187 12.3594 1.5 12.5375 1.5 12.75C1.5 12.9625 1.57187 13.1406 1.71562 13.2844C1.85938 13.4281 2.0375 13.5 2.25 13.5ZM7.5 13.5C7.7125 13.5 7.89062 13.4281 8.03438 13.2844C8.17812 13.1406 8.25 12.9625 8.25 12.75C8.25 12.5375 8.17812 12.3594 8.03438 12.2156C7.89062 12.0719 7.7125 12 7.5 12C7.2875 12 7.10937 12.0719 6.96562 12.2156C6.82187 12.3594 6.75 12.5375 6.75 12.75C6.75 12.9625 6.82187 13.1406 6.96562 13.2844C7.10937 13.4281 7.2875 13.5 7.5 13.5ZM12.75 13.5C12.9625 13.5 13.1406 13.4281 13.2844 13.2844C13.4281 13.1406 13.5 12.9625 13.5 12.75C13.5 12.5375 13.4281 12.3594 13.2844 12.2156C13.1406 12.0719 12.9625 12 12.75 12C12.5375 12 12.3594 12.0719 12.2156 12.2156C12.0719 12.3594 12 12.5375 12 12.75C12 12.9625 12.0719 13.1406 12.2156 13.2844C12.3594 13.4281 12.5375 13.5 12.75 13.5ZM7.5 3C7.7125 3 7.89062 2.92812 8.03438 2.78437C8.17812 2.64062 8.25 2.4625 8.25 2.25C8.25 2.0375 8.17812 1.85938 8.03438 1.71562C7.89062 1.57187 7.7125 1.5 7.5 1.5C7.2875 1.5 7.10937 1.57187 6.96562 1.71562C6.82187 1.85938 6.75 2.0375 6.75 2.25C6.75 2.4625 6.82187 2.64062 6.96562 2.78437C7.10937 2.92812 7.2875 3 7.5 3Z" fill="currentColor"/>
          </svg>
        </template>
        <template #icon-1="{ selected }">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15H11.25V13.5H7.5C4.245 13.5 1.5 10.755 1.5 7.5C1.5 4.245 4.245 1.5 7.5 1.5C10.755 1.5 13.5 4.245 13.5 7.5V8.5725C13.5 9.165 12.9675 9.75 12.375 9.75C11.7825 9.75 11.25 9.165 11.25 8.5725V7.5C11.25 5.43 9.57 3.75 7.5 3.75C5.43 3.75 3.75 5.43 3.75 7.5C3.75 9.57 5.43 11.25 7.5 11.25C8.535 11.25 9.48 10.83 10.155 10.1475C10.6425 10.815 11.4825 11.25 12.375 11.25C13.8525 11.25 15 10.05 15 8.5725V7.5C15 3.36 11.64 0 7.5 0ZM7.5 9.75C6.255 9.75 5.25 8.745 5.25 7.5C5.25 6.255 6.255 5.25 7.5 5.25C8.745 5.25 9.75 6.255 9.75 7.5C9.75 8.745 8.745 9.75 7.5 9.75Z" fill="currentColor"/>
          </svg>
        </template>
        <template #icon-2="{ selected }">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
            <path d="M7.9875 14.7375C7.05 14.7375 6.17188 14.5594 5.35313 14.2031C4.53438 13.8469 3.82188 13.3656 3.21563 12.7594C2.60938 12.1531 2.12813 11.4406 1.77188 10.6219C1.41563 9.80313 1.2375 8.925 1.2375 7.9875C1.2375 7.05 1.41563 6.17188 1.77188 5.35313C2.12813 4.53438 2.60938 3.82187 3.21563 3.21562C3.82188 2.60938 4.53438 2.12812 5.35313 1.77187C6.17188 1.41562 7.05 1.2375 7.9875 1.2375C8.925 1.2375 9.80313 1.41562 10.6219 1.77187C11.4406 2.12812 12.1531 2.60938 12.7594 3.21562C13.3656 3.82187 13.8469 4.53438 14.2031 5.35313C14.5594 6.17188 14.7375 7.05 14.7375 7.9875C14.7375 8.925 14.5594 9.80313 14.2031 10.6219C13.8469 11.4406 13.3656 12.1531 12.7594 12.7594C12.1531 13.3656 11.4406 13.8469 10.6219 14.2031C9.80313 14.5594 8.925 14.7375 7.9875 14.7375ZM10.0875 11.1375L11.1375 10.0875L8.7375 7.6875V4.2375H7.2375V8.2875L10.0875 11.1375ZM3.1875 0L4.2375 1.05L1.05 4.2375L0 3.1875L3.1875 0ZM12.7875 0L15.975 3.1875L14.925 4.2375L11.7375 1.05L12.7875 0ZM7.9875 13.2375C9.45 13.2375 10.6906 12.7281 11.7094 11.7094C12.7281 10.6906 13.2375 9.45 13.2375 7.9875C13.2375 6.525 12.7281 5.28438 11.7094 4.26562C10.6906 3.24688 9.45 2.7375 7.9875 2.7375C6.525 2.7375 5.28438 3.24688 4.26563 4.26562C3.24688 5.28438 2.7375 6.525 2.7375 7.9875C2.7375 9.45 3.24688 10.6906 4.26563 11.7094C5.28438 12.7281 6.525 13.2375 7.9875 13.2375Z" fill="currentColor"/>
          </svg>
        </template>
        <template #icon-3="{ selected }">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
            <path d="M6.66667 14.8113V8.98875L1.66667 6.035V11.8575L6.66667 14.8113ZM8.33333 14.8113L13.3333 11.8575V6.035L8.33333 8.98875V14.8113ZM6.66667 16.7663L0.833333 13.345C0.569444 13.1892 0.364583 12.9838 0.21875 12.7288C0.0729167 12.4738 0 12.1904 0 11.8788V5.12125C0 4.80958 0.0729167 4.52625 0.21875 4.27125C0.364583 4.01625 0.569444 3.81083 0.833333 3.655L6.66667 0.23375C6.93056 0.0779167 7.20833 0 7.5 0C7.79167 0 8.06944 0.0779167 8.33333 0.23375L14.1667 3.655C14.4306 3.81083 14.6354 4.01625 14.7813 4.27125C14.9271 4.52625 15 4.80958 15 5.12125V11.8788C15 12.1904 14.9271 12.4738 14.7813 12.7288C14.6354 12.9838 14.4306 13.1892 14.1667 13.345L8.33333 16.7663C8.06944 16.9221 7.79167 17 7.5 17C7.20833 17 6.93056 16.9221 6.66667 16.7663ZM10.8333 5.54625L12.4375 4.61125L7.5 1.7L5.875 2.65625L10.8333 5.54625ZM7.5 7.5225L9.125 6.56625L4.1875 3.655L2.5625 4.61125L7.5 7.5225Z" fill="currentColor"/>
          </svg>
        </template>
      </Tab>
      <button class="notification-tabs__close" @click="$emit('close')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#374957"/>
        </svg>
      </button>
    </div>

    <!-- Tab content -->
    <div class="notification-tabs__content">
      <AutomationsTab v-if="activeTab === 'automations'" />
      <MentionsTab v-else-if="activeTab === 'mentions'" @jump-to-conversation="$emit('jump-to-conversation', $event)" />
      <TasksTab v-else-if="activeTab === 'tasks'" />
      <OrdersTab v-else-if="activeTab === 'orders'" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AutomationsTab from './AutomationsTab.vue';
import MentionsTab from './MentionsTab.vue';
import TasksTab from './TasksTab.vue';
import OrdersTab from './OrdersTab.vue';

export default {
  name: 'NotificationTabs',
  components: { AutomationsTab, MentionsTab, TasksTab, OrdersTab },
  emits: ['close', 'jump-to-conversation'],
  data() {
    return {
      tabs: [
        { key: 'automations', label: 'Automations', badgeColor: '#EF5DA8' },
        { key: 'mentions', label: 'Mentions', badgeColor: '#FF956C' },
        { key: 'tasks', label: 'Tasks', badgeColor: '#588B8B' },
        { key: 'orders', label: 'Orders', badgeColor: '#5D5FEF' },
      ],
    };
  },
  computed: {
    ...mapState('notifications', ['activeTab']),
    ...mapGetters('notifications', ['badgeCounts']),
    tabConfig() {
      return this.tabs.map(tab => {
        const count = this.badgeCounts[tab.key];
        return {
          value: tab.key,
          label: tab.label,
          icon: true,
          badge: count > 0
            ? { content: count, customized_theme_color: tab.badgeColor }
            : false,
        };
      });
    },
  },
  mounted() {
    // Load robot state for badge counts and default tab
    this.$store.dispatch('notifications/fetchRobotState');
    this.$store.dispatch('notifications/setActiveTab', 'automations');
  },
  methods: {
    switchTab(tab) {
      this.$store.dispatch('notifications/setActiveTab', tab);
    },
  },
};
</script>

<style scoped>
.notification-tabs {
  background: var(--Cool-White, #F9FBFD);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 12px 20px 24px;
  box-sizing: border-box;
}

.notification-tabs__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.notification-tabs__tab-group {
  flex: 1;
  min-width: 0;
}

.notification-tabs__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.notification-tabs__content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  margin-top: 32px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
